import { render, staticRenderFns } from "./BlockedUsers.vue?vue&type=template&id=1c2ac740"
import script from "./BlockedUsers.vue?vue&type=script&lang=js"
export * from "./BlockedUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports